module.exports = __webpack_public_path__ + "static/media/alexdocas222.ee752b37.png";